import type { PropsWithChildren, ReactNode } from 'react';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
    navigationRouterDiv: {
        paddingLeft: 50,
        paddingRight: 50,
    },

    [theme.breakpoints.up('lg')]: {
        navigationRouterDiv: {
            paddingLeft: 100,
            paddingRight: 100,
            marginBottom: 10,
        },
    },
    [theme.breakpoints.up('xl')]: {
        navigationRouterDiv: {
            paddingLeft: 200,
            paddingRight: 200,
            marginBottom: 10,
        },
    },

    navigationRouterContentDiv: {
        overflow: 'hidden',
        fontSize: 14,
    },
    navigationRouterContentLeft: {
        float: 'left',
        color: theme.bino.color.lightPurple,
        paddingTop: 14,
    },
    navigationRouterContentRight: {
        float: 'left',
        paddingLeft: 5,
    },
}));

export type NavigationRouterProps = PropsWithChildren<{
    navigationRouter: ReactNode;
    className?: string;
    baseRoute: string;
}>;
export function NavigationRouter(props: NavigationRouterProps) {
    const { children, navigationRouter, className, baseRoute } = props;
    const { classes, cx } = useStyles();

    return (
        <div className={classes.navigationRouterDiv}>
            <div className={classes.navigationRouterContentDiv}>
                <a
                    href={baseRoute}
                    className={cx(
                        className,
                        classes.navigationRouterContentLeft,
                    )}
                >
                    {children}
                </a>
                {navigationRouter ? (
                    <p
                        className={cx(
                            className,
                            classes.navigationRouterContentRight,
                        )}
                    >
                        {navigationRouter}
                    </p>
                ) : null}
            </div>
        </div>
    );
}

export default NavigationRouter;
